function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, isValidElement, cloneElement, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import TooltipArrow from './TooltipArrow';
import FocusTrap from '../FocusTrap';
import ClickAway from '../ClickAway';
import Button from '../Button';
import Icon from '../Icon';

var getTooltipMargin = function getTooltipMargin(placement) {
  switch (placement) {
    case 'top':
      return 'psw-m-b-5';

    case 'bottom':
      return 'psw-m-t-5';

    case 'left':
      return 'psw-m-r-5';

    case 'right':
      return 'psw-m-l-5';

    default:
      return 'psw-m-b-5';
  }
};

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, children);
};

Wrapper.propTypes = {
  children: PropTypes.node.isRequired
};
/**
 * Tooltip provides additional context to users but needs extra care when integrating to ensure
 * it's use is accessible for all.
 *
 * - [Designs in Atlas](https://atlas.np.tools.playstation.net/design/43a29cb9-dab3-4303-81cc-c887f9b7d53f/1?bounds=0.031,2.974,0.974,0.653)
 * - [Accesibility concerns for tooltips](https://sarahmhigley.com/writing/tooltips-in-wcag-21/)
 */

var Tooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    _this.rootRef = props.node || /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          qa = _this$props.qa,
          className = _this$props.className,
          header = _this$props.header,
          body = _this$props.body,
          cta = _this$props.cta,
          placement = _this$props.placement,
          show = _this$props.show,
          trapFocus = _this$props.trapFocus,
          onClickAway = _this$props.onClickAway,
          onEscape = _this$props.onEscape,
          hideArrow = _this$props.hideArrow,
          arrowXDiff = _this$props.arrowXDiff,
          arrowYDiff = _this$props.arrowYDiff,
          onClickCloseButton = _this$props.onClickCloseButton,
          variant = _this$props.variant,
          closeButtonLabel = _this$props.closeButtonLabel,
          autoFocus = _this$props.autoFocus;
      var hasValidCta = /*#__PURE__*/isValidElement(cta);
      /**
       * The shared ref needs to be mounted and exist before rendering the ClickAway
       * and FocusTrap components.
       */

      var ClickAwayNode = this.rootRef.current ? ClickAway : Wrapper;
      var FocusTrapNode = this.rootRef.current && autoFocus ? FocusTrap : Wrapper;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.rootRef,
        id: id,
        "data-qa": qa,
        "aria-hidden": !show,
        className: classNames(className, 'psw-l-w-tooltip')
      }, /*#__PURE__*/React.createElement(ClickAwayNode, {
        node: this.rootRef,
        onClickAway: onClickAway
      }, /*#__PURE__*/React.createElement(FocusTrapNode, {
        node: this.rootRef,
        onEscape: onEscape,
        trap: trapFocus
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-tooltip', {
          'psw-is-visible': show
        }, 'psw-l-anchor', 'psw-l-stack-center', variant === 'blueBgColor' ? 'psw-bg-blue-tooltip' : 'psw-c-bg-1', 'psw-p-x-5', 'psw-p-t-5', 'psw-p-b-3', 'psw-r-3', 'psw-s-feature', getTooltipMargin(placement))
      }, onClickCloseButton && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-r-oval', 'psw-close-button-tooltip')
      }, /*#__PURE__*/React.createElement(Button, {
        className: classNames('psw-l-line-center', 'psw-b-2', 'psw-c-b-tooltip'),
        qa: "".concat(qa, "#close-button"),
        ctaType: "primary-1",
        variant: "quick-action",
        iconOnly: true,
        onClick: onClickCloseButton
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "close",
        className: classNames('psw-r-oval', 'psw-bg-blue-tooltip', 'psw-bg-blue-tooltip-text'),
        label: closeButtonLabel
      }))), (!!header || !!onClickCloseButton) && /*#__PURE__*/React.createElement("h2", {
        "data-qa": "".concat(qa, "#header"),
        className: classNames('psw-t-body', 'psw-m-b-5')
      }, header), !!body && /*#__PURE__*/React.createElement("p", {
        "data-qa": "".concat(qa, "#body"),
        className: classNames('psw-t-2', variant === 'blueBgColor' ? 'psw-bg-blue-text-tooltip  psw-t-align-c' : 'psw-c-t-2', 'psw-m-b-3')
      }, body), hasValidCta && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-m-t-3')
      }, hasValidCta && /*#__PURE__*/cloneElement(cta, {
        qa: "".concat(qa, "#cta"),
        ctaType: 'tertiary',
        'aria-hidden': true
      })), /*#__PURE__*/React.createElement(TooltipArrow, {
        placement: placement,
        xDiff: arrowXDiff,
        yDiff: arrowYDiff,
        hide: hideArrow,
        variant: variant
      })))));
    }
  }]);

  return Tooltip;
}(PureComponent);

Tooltip.defaultProps = {
  id: '',
  qa: '',
  className: '',
  show: false,
  header: null,
  body: null,
  cta: null,
  placement: 'bottom',
  arrowXDiff: 0,
  arrowYDiff: 0,
  hideArrow: false,
  trapFocus: false,
  node: null,
  onClickAway: function onClickAway() {},
  onEscape: function onEscape() {},
  onClickCloseButton: undefined,
  variant: 'default',
  closeButtonLabel: '',
  autoFocus: true
};
Tooltip.propTypes = {
  /**
   * Unique id to allow associating the tooltip content with another element via
   * aria-describedby or aria-labelledby depending on your use case
   */
  id: PropTypes.string,

  /**
   * Root qa test automation id
   */
  qa: PropTypes.string,

  /**
   * Add additional css classes to the component
   */
  className: PropTypes.string,

  /**
   * Whether the tooltip should be shown or not
   */
  show: PropTypes.bool,

  /**
   * The tooltip title
   */
  header: PropTypes.node,

  /**
   * The tooltip description
   */
  body: PropTypes.node,

  /**
   * CTA to dismiss the tooltip
   */
  cta: PropTypes.node,

  /**
   * The placement determines the orientation of the tooltip pointer. For actual
   * placement relative to an item see AnchoredTooltip.
   */
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),

  /**
   * Arrow adjustment along the x axis
   */
  arrowXDiff: PropTypes.number,

  /**
   * Arrow adjustment along the y axis
   */
  arrowYDiff: PropTypes.number,

  /**
   * Whether to hide the arrow
   */
  hideArrow: PropTypes.bool,

  /**
   * Callback to be called when escaped key is pressed when tooltip is focused
   */
  onEscape: PropTypes.func,

  /**
   * Callback to be called when user clicks outside of tooltip
   */
  onClickAway: PropTypes.func,

  /**
   * Whether tooltip should trap focus
   */
  trapFocus: PropTypes.bool,

  /**
   * React ref to pass through
   */
  node: PropTypes.element,

  /**
   * determines some visual styles of tooltip
   *
  */
  variant: PropTypes.oneOf(['default', 'blueBgColor']),

  /**
   * callback that execute on close button that appears on top right corner. If no
   * callback is provided, close button does not display.
   *
  */
  onClickCloseButton: PropTypes.func,

  /**
   * the label for the close button
   */
  closeButtonLabel: PropTypes.string,

  /**
   * prevent tooltip from getting auto focus
   * on mount
   */
  autoFocus: PropTypes.bool
};
export default Tooltip;